import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAttachmentsFilesDTO } from 'src/app/_interfaces/medical-tests/i-medical-test-details';
import { GenericResponse } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root',
})
export class PrescriptionService {
  getPrescriptionRequestsUrl: string =
    'api/AdminEhrPrescriptionFulfillments/GetEhrPrescriptionFulfillmentRequests';
  getAdminPrescriptionRequestDetailsUrl: string =
    'api/AdminEhr/GetAdminPrescriptionRequestDetails';
  uploadTestResultsForAdminPrescriptionRequestDetailsUrl: string =
    'api/AdminPrescriptions/UploadTestResultsForAdminPrescriptionRequestDetails';
  updateRequestStatusUrl: string =
    'api/AdminEhrPrescriptionFulfillments/UpdateRequestStatus';
  uploadTestResultsUrl: string  = 'api/AdminEhrPrescriptionFulfillments/UploadTestResultsForAdminPrescriptionRequestDetails';
  exportExcelUrl:string = 'api/AdminEhrPrescriptionFulfillments/GetAllEhrPrescriptionFulfillmentRequestsExcel'

  constructor(private httpClient: HttpClient) {}

  getPrescriptionRequests(paramsObject): Observable<any> {
    let params = new HttpParams().set('statusId', paramsObject.statusId)
      .append('prescriptionTypeId', paramsObject.prescriptionTypeId);

    params = paramsObject.patientNameOrMobile
      ? params.set('patientNameOrMobile', paramsObject.patientNameOrMobile)
      : params;

    params = paramsObject.fromDate
      ? params.set('fromDate', paramsObject.fromDate)
      : params;
    params = paramsObject.toDate
      ? params.set('toDate', paramsObject.toDate)
      : params;

    params = paramsObject.currentPage
      ? params.set('currentPage', paramsObject.currentPage)
      : params;

    params = paramsObject.pageSize
      ? params.set('pageSize', paramsObject.pageSize)
      : params;

    return this.httpClient.get(this.getPrescriptionRequestsUrl, {
      params: params,
    });
  }

  getAdminPrescriptionRequestDetails(requestId): Observable<any> {
    let params = new HttpParams().set('requestId', requestId);

    return this.httpClient.get(this.getAdminPrescriptionRequestDetailsUrl, {
      params: params,
    });
  }

  getExportExcel(statusId, fulfillmentType):Observable<any>{
    let params = new HttpParams()
    .set('statusId', statusId)
    .set('fulfillmentType',fulfillmentType.toString())
    return this.httpClient.get(this.exportExcelUrl,{params});
  }

  uploadResult(prescriptionRequestId, resultFile): Observable<any> {
    let formData = new FormData();
    formData.append('Id', prescriptionRequestId);
    formData.append('Result', resultFile);

    return this.httpClient.put(
      this.uploadTestResultsForAdminPrescriptionRequestDetailsUrl,
      formData
    );
  }

  uploadTestResults(ehrTransactionId, resultFiles): Observable<GenericResponse<IAttachmentsFilesDTO>> {
    let formData = new FormData();
    formData.append('ehrTransactionId', ehrTransactionId);
    resultFiles.forEach((file) => { formData.append('files', file); })

    return this.httpClient.put<GenericResponse<IAttachmentsFilesDTO>>(
      this.uploadTestResultsUrl,
      formData
    );
  }

  updateRequestStatus(requestId, statusId, type): Observable<any> {
    let params = new HttpParams()
      .set('RequestId', requestId)
      .set('StatusId', statusId)
      .set('Type', type);

    return this.httpClient.put(this.updateRequestStatusUrl, {
      requestId: requestId,
      statusId: statusId,
      type: type,
    });
  }
}
